import script from "./Account.vue?vue&type=script&setup=true&lang=ts"
export * from "./Account.vue?vue&type=script&setup=true&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=713f3b51&scoped=true&lang=scss"

import exportComponent from "C:\\repos\\1File_WebClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-713f3b51"]])

export default __exports__